import React from "react"
import { Link } from "gatsby"
import ModalOferta from "../Modals/ModalOferta"
import ModalCennik from "../Modals/ModalCennikPromo3week"
// import ModalCennik from "../Modals/ModalCennik"

import AppleStore from "../../images/appstore.png"
import GooglePlay from "../../images/googleplay.png"

const Oferta = ({ data }) => {
  const [modOfertaShow, setModOfertaShow] = React.useState(false)
  const [modCennikShow, setModCennikShow] = React.useState(false)

  return (
    <section id="our-services" className="py-5 oferta">
      <div className="container">
        <h2 className="text-center mb-5 font-light section-title">
          OUR SERVICES
        </h2>
        <div className="row justify-content-center">
          <div className="col-12 col-md-6 col-xl-4 mb-3">
            <button
              className="btn btn-primary font-xxl text-uppercase font-bold p-3 w-100 rounded-xl h-100"
              onClick={() => setModCennikShow(true)}
            >
              RETAIL CUSTOMERS
            </button>
          </div>
          <div className="col-12 col-md-6 col-xl-4 mb-3">
            <a
              className="btn btn-primary font-xxl text-uppercase font-bold p-3 w-100 rounded-xl h-100" style={{display:'inline-flex', alignItems:'center', justifyContent:'center'}}
              // onClick={() => setModOfertaShow(true)}
              href="https://flota.orlen.pl/Artykul/elektromobilnosc" target="_blank" rel="noreferrer"
            >
              FLEET/BUSINESS CUSTOMERS
            </a>
          </div>
          <div className="col-12 col-md-6 col-xl-4 mb-3">
            <a
              className="btn btn-primary font-xxl text-uppercase font-bold p-3 w-100 rounded-xl h-100" style={{display:'inline-flex', alignItems:'center', justifyContent:'center'}}
              // onClick={() => setModOfertaShow(true)}
              href="https://www.energa.pl/biznes/uslugi/stacje-ladowania.html#2" target="_blank" rel="noreferrer"
            >
              Charging stations purchase
            </a>
          </div>
        </div>

        <p className="col-xl-10 m-xl-auto py-5 text-center font-xxl font-light">
          We are a Public Electric Vehicle Charging Station Network Operator and
          Charging Service Provider.
        </p>
        <div className="row">
          <div
            data-sal="slide-up"
            data-sal-delay="500"
            data-sal-duration="600"
            data-sal-easing="ease"
            className="ie11animfix col-12 col-sm-6 col-xl-3 px-sm-4 px-xxl-5 mb-5 d-flex flex-wrap justify-content-center align-content-between"
          >
            <figure className="text-center mb-3 mb-xl-5 icon-holder">
              <span className="icon-icon-1"></span>
            </figure>
            <div className="mb-3 mb-xl-5 flex-grow-1">
              <p className="text-center">
                Check out our <strong>charging fees</strong>
              </p>
            </div>
            <div className="w-100 flex-grow-0">
              <button
                className="button-blank link-more"
                onClick={() => setModCennikShow(true)}
                title="Check out our charging fees"
              >
                Pricing
              </button>
            </div>
          </div>
          <div
            data-sal="slide-up"
            data-sal-delay="600"
            data-sal-duration="600"
            data-sal-easing="ease"
            className="ie11animfix col-12 col-sm-6 col-xl-3 px-sm-4 px-xxl-5 mb-5 d-flex flex-wrap justify-content-center align-content-between"
          >
            <figure className="text-center mb-3 mb-xl-5 icon-holder">
              <span className="icon-icon-2"></span>
            </figure>
            <div className="mb-3 mb-xl-5 flex-grow-1">
              <p className="text-center">
                Find out more
                <strong> about chargers available at ORLEN stations</strong>
              </p>
            </div>
            <div className="w-100 flex-grow-0">
              <Link
                to="our-chargers"
                className="link-more"
                title="Find out more about chargers available at ORLEN stations"
              >
                Our chargers
              </Link>
            </div>
          </div>
          <div
            data-sal="slide-up"
            data-sal-delay="700"
            data-sal-duration="600"
            data-sal-easing="ease"
            className="ie11animfix col-12 col-sm-6 col-xl-3 px-sm-4 px-xxl-5 mb-5 d-flex flex-wrap justify-content-center align-content-between"
          >
            <figure className="text-center mb-3 mb-xl-5 icon-holder">
              <span className="icon-icon-3"></span>
            </figure>
            <div className="mb-3 mb-xl-5 flex-grow-1">
              <p className="text-center">
                Download the <strong>ORLEN Charge app</strong> to use our
                chargers
              </p>
            </div>
            <div className="row mb-2 w-100">
              <div className="col-6">
                <a
                  href="https://apps.apple.com/us/app/orlen-charge/id1478111353"
                  target="_blank"
                  rel="noreferrer"
                  title="install app from App Store"
                >
                  <img src={AppleStore} alt="" className="img-fluid" />
                </a>
              </div>
              <div className="col-6">
                <a
                  href="https://play.google.com/store/apps/details?id=pl.orlen.charge"
                  target="_blank"
                  rel="noreferrer"
                  title="install app from Google Play"
                >
                  <img src={GooglePlay} alt="" className="img-fluid" />
                </a>
              </div>
            </div>
          </div>
          <div
            data-sal="slide-up"
            data-sal-delay="800"
            data-sal-duration="600"
            data-sal-easing="ease"
            className="ie11animfix col-12 col-sm-6 col-xl-3 px-sm-4 px-xxl-5 mb-5 d-flex flex-wrap justify-content-center align-content-between"
          >
            <figure className="text-center mb-3 mb-xl-5 icon-holder">
              <span className="icon-icon-4"></span>
            </figure>
            <div className="mb-3 mb-xl-5 flex-grow-1">
              <p className="text-center">
                Learn&nbsp;
                <strong>how to use ORLEN chargers</strong>
              </p>
            </div>
            <div className="w-100 flex-grow-0">
              <Link
                to="charging-instructions"
                className="link-more"
                title="Learn how to use ORLEN chargers"
              >
                Charging instructions
              </Link>
            </div>
          </div>
        </div>
      </div>
      <ModalOferta
        show={modOfertaShow}
        handleclose={() => setModOfertaShow(false)}
      />
      <ModalCennik
        show={modCennikShow}
        handleclose={() => setModCennikShow(false)}
      />
    </section>
  )
}


export default Oferta

